import { useEffect, useId } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import type { VpnAssessment } from '@/src/lib/vpnAssessment'
import { Toast } from '@/src/components/Toast/Toast'

import styles from './VpnConnectionNotice.module.css'

/** Данные уведомления без собственного кеша или сетевых запросов. */
interface VpnConnectionNoticeProps {
  roomName: string
  assessment: VpnAssessment | null
  shouldWarn: boolean
  onShown: () => void
}

/**
 * Показывает одно закрываемое предупреждение за заход и обязательную атрибуцию геобазы.
 * @param props — вердикт и разрешение показа от владельца сессии звонка.
 */
export function VpnConnectionNotice({
  roomName,
  assessment,
  shouldWarn,
  onShown,
}: VpnConnectionNoticeProps) {
  const { t } = useTranslation()
  const id = useId()
  const toastId = `vpn-connection-${id}`

  useEffect(
    () => () => {
      toast.dismiss(toastId)
    },
    [roomName, toastId],
  )

  useEffect(() => {
    if (!shouldWarn) {
      return
    }

    onShown()
    toast.warn(<Toast description={t('vpnConnectionHint')} />, {
      toastId,
      position: 'bottom-right',
      className: styles.toast,
      autoClose: false,
      closeOnClick: false,
      role: 'alert',
    })
  }, [shouldWarn, onShown, t, toastId])

  if (assessment?.status !== 'assessed') {
    return null
  }

  return (
    <a
      className={styles.attribution}
      href="https://db-ip.com/"
      target="_blank"
      rel="noopener noreferrer"
    >
      IP Geolocation by DB-IP
    </a>
  )
}
